import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Helmet from 'react-helmet';
import Fa from 'react-fontawesome';
import { toast } from 'react-toastify';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import StickyBox from 'react-sticky-box';
import {
  find, findIndex, first, filter, delay,
  orderBy, range, each, concat, map, capitalize, debounce,
} from 'lodash';
import BodyClassName from 'react-body-classname';
import { List, WindowScroller, AutoSizer, CellMeasurerCache, CellMeasurer } from 'react-virtualized';
import { fetchPrograms } from '../../../Nomination/NominationActions';
import { getPrograms } from '../../../Nomination/NominationReducer';
import { 
  getUser,
  getCanSetupOrganization,
} from '../../../Auth/AuthReducer';
import { fetchTVProductMappings, sendReminderEmail, sendSummaryEmail } from '../../../Setup/SetupActions';
import NumberDisplay from '../../../../components/number-display';
import SearchForm from '../../../../components/search-form';
import { getHasNoDecisionSetup } from '../../../../components/search-form/search-form-reducer';
import SurveyEmailModal from '../../../Dashboard/components/SurveyEmailModal';
import InsightModal from '../../components/sidebox/InsightModal';
import createRequestFeedbackComponent, { ACCOUNT_COMPONENT_TYPE } from '../../../Dashboard/components/WinLossOpportunityTable/RequestOpportunityFeedbacks';
import EditLanguageModal from '../../components/edit-language-modal';
import SubNav from '../../components/nav';
import SideBox from '../../components/sidebox';
import SearchField from '../../../../components/search-field';
import AccountBox from '../../components/account-box';
import { getHeaderHeight, getFooterHeight, getWindowWidth } from '../../../App/AppReducer';
import Shimmer from '../../components/opportunity-box/Shimmer';
import RequiredTVCollectorMappingSetup from '../../../Setup/pages/TruVoiceCollectorsPage/RequiredTVCollectorMappingSetup';
import OutreachPlanModal from '../../components/outreach-plan-modal';
import EditSenderModal from '../../components/edit-sender-modal';
import CommunicationRecipientModal from '../../components/communication-recipient';
import CancelOutreachForm from '../../components/opportunity-box/CancelOutReachForm';
import ExcludeOpportunityForm from '../../components/opportunity-box/ExcludeOpportunityForm';
import AutomationTestModal from '../../../Setup/pages/DiscoveryBotPage/AutomationTestModal';
import AccountModal from '../../../Dashboard/components/AccountTable/modal';
import { resetAccountAutomationSettings } from '../../../Setup/SetupActions';
import { getColumnData } from '../../../../components/god-table/reducer';
import ProgessBar from '../../../../components/progress-bar';

import {
  resetAll,
  fetchFeedbackExperienceOpportunities,
  fetchAccountInsights,
  requestEditWinLossAccountFeedbacks,
  updateAccountStatus,
  fetchCollectorStats,
  loadSettings,
  winLossCancelSurveys,
  fetchWinLossAccountSurveys,
  winLossExcludeAccount,
  winLossIncludeAccount,
  fetchOpportunityRequestStatus,
  updateReminderEmailStatus,
} from '../../../Dashboard/DashboardActions';
import ColumnDataManager from '../../../../components/god-table/column-data-manager';

import {
  getWinLossLoading,
  getWinLossLoaded,
  getWinLossAccounts,
  getWinLossFeedbackLoaded,
  getWinLossCollectorStats,
} from '../../../Dashboard/DashboardReducer';

import styles from '../DecisionPage/styles.css';

const RequestOpportunityFeedbacks = createRequestFeedbackComponent(ACCOUNT_COMPONENT_TYPE);

const sortOptions = [
  {
    label: 'FEEDBACK DATE', value: 'feedback_date', isHeader: true,
  },
  {
    label: 'Newest First', longLabel: 'Feedback Date, Newest', value: 'feedback_date_desc', sortKey: 'max_feedback_date', sortDir: 'desc',
  },
  {
    label: 'Oldest First', longLabel: 'Feedback Date, Oldest', value: 'feedback_date_asc', sortKey: 'min_feedback_date', sortDir: 'asc',
  },

  {
    label: 'REQUEST DATE', value: 'request_date', isHeader: true,
  },
  {
    label: 'Newest First', longLabel: 'Request Date, Newest', value: 'request_date_desc', sortKey: 'max_request_date', sortDir: 'desc',
  },
  {
    label: 'Oldest First', longLabel: 'Request Date, Oldest', value: 'request_date_asc', sortKey: 'min_request_date', sortDir: 'asc',
  },

  {
    label: 'Trailing Twelve Month', value: 'ttm_value', isHeader: true,
  },
  {
    label: 'Largest First', longLabel: 'TTM Value, Descending', value: 'ttm_desc', sortKey: 'ttm', sortDir: 'desc', icon: 'sort-numeric-desc',
  },
  {
    label: 'Smallest First', longLabel: 'TTM Value, Ascending', value: 'ttm_asc', sortKey: 'ttm', sortDir: 'asc', icon: 'sort-numeric-asc',
  },

  {
    label: 'Lifetime Value', value: 'ltv_value', isHeader: true,
  },
  {
    label: 'Largest First', longLabel: 'LTV Value, Descending', value: 'ltv_desc', sortKey: 'ltv', sortDir: 'desc', icon: 'sort-numeric-desc',
  },
  {
    label: 'Smallest First', longLabel: 'LTV Value, Ascending', value: 'ltv_asc', sortKey: 'ltv', sortDir: 'asc', icon: 'sort-numeric-asc',
  },

  {
    label: 'ACCOUNT NAME', value: 'account_name', isHeader: true,
  },
  {
    label: 'Ascending', longLabel: 'Name, Ascending', value: 'account_asc', sortKey: 'name', sortDir: 'asc', icon: 'sort-alpha-asc',
  },
  {
    label: 'Descending', longLabel: 'Name, Descending', value: 'account_desc', sortKey: 'name', sortDir: 'desc', icon: 'sort-alpha-desc',
  },

  {
    label: 'CUSTOMER STATUS', value: 'customer_status', isHeader: true,
  },
  {
    label: 'Ascending', longLabel: 'Status, Ascending', value: 'customer_status_asc', sortKey: 'customer_status', sortDir: 'asc', icon: 'sort-alpha-asc',
  },
  {
    label: 'Descending', longLabel: 'Status, Descending', value: 'customer_status_desc', sortKey: 'customer_status', sortDir: 'desc', icon: 'sort-alpha-desc',
  },

];
const filterOptions = [
  {
    label: 'All Accounts', value: null, filters: null,
  },
  {
    label: 'Have Feedback', value: 'have_feedback', filters: { has_feedbacks: true },
  },
  {
    label: 'Need Feedback', value: 'need_feedback', filters: { need_reasons: true, has_requests: false },
  },
  {
    label: 'Requesting Feedback', value: 'requesting_feedback', filters: { in_outreach: true },
  },
  {
    label: 'Past Customers', value: 'past_customer', filters: { customer_status: 'past' },
  },
  {
    label: 'Current Customers', value: 'current_customer', filters: { customer_status: 'current' },
  },
  {
    label: 'Prospects', value: 'prospect_customer', filters: { customer_status: null },
  },
  {
    label: 'Excluded', value: 'excluded', filters: { excluded: true },
  },
];


const LIMIT_CHARS = 3;
const includeResources = ['accounts', 'owners', 'accountWebsite', 'contactRoles', 'accountContactCount', 'lineItems', 'accountIndustries', 'internalEmailCount']

class ExperiencePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      query: null,
      tabs: {},
      colorPalletes: {},
      selectedFilter: null,
      selectedSort: 'account_asc', // default
      accounts: [],
      amountField: 'ttm', // ttm = trailling twelve month, ltv: life time value
      currentSurveyPlan: null,
      currentEditSenderSurvey: null,
      currentEditLanguageSurvey: null,
      selectedLanguage: null,
      availableLanguages: [],
      currentCancelContact: null,
      currentCancelContactObject: null,
      cancelContactCallBack: null,
      currentlyExcludedAccount: null,
      currentEditCommnunicationRecipient: null,
      showTestModal: false,
      testOwnerId: null,
      testAccountId: null, 
      testAutomationId: null,
      selectedAccountIds: [],
      showExcluedReason: false,
      backendQuickSearching: false,
      hasBackendResults: false,
      searchId: 0,
      priorityData: [],
    };
    this.handleFormChange = this.handleFormChange.bind(this);
    this.hanldeReset = this.hanldeReset.bind(this);
    this.rowRenderer = this.rowRenderer.bind(this);
    this.handleSearch = debounce(this.handleSearch.bind(this), 500, {});
    this.handleTabSelect = this.handleTabSelect.bind(this);
    this.handleOnAccountLogoLoaded = this.handleOnAccountLogoLoaded.bind(this);
    this.keyMapper = this.keyMapper.bind(this);
    this.handleRequestShowInsight = this.handleRequestShowInsight.bind(this);
    this.handleSelectSortOption = this.handleSelectSortOption.bind(this);
    this.handleSelectFilterOption = this.handleSelectFilterOption.bind(this);
    this.requestAddAccountSurvey = this.requestAddAccountSurvey.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.handleOnSubmitContacts = this.handleOnSubmitContacts.bind(this);
    this.handleSubmitContactAndDone = this.handleSubmitContactAndDone.bind(this);
    this.handleSelectAmountFieldOption = this.handleSelectAmountFieldOption.bind(this);
    this.handleUpdateAccountStatus = this.handleUpdateAccountStatus.bind(this);
    this.handleRequestShowOutreachPlan = this.handleRequestShowOutreachPlan.bind(this);
    this.handleRequestFetchCollectorStats = this.handleRequestFetchCollectorStats.bind(this);
    this.requestChangeSenderEmail = this.requestChangeSenderEmail.bind(this);
    this.requestChangeLanguage = this.requestChangeLanguage.bind(this);
    this.handleRequestCancel = this.handleRequestCancel.bind(this);
    this.handleCancelOutreach = this.handleCancelOutreach.bind(this);

    this.requestExcludeAccount = this.requestExcludeAccount.bind(this);
    this.handleIncludeAccount = this.handleIncludeAccount.bind(this);
    this.handleExcludeAccount = this.handleExcludeAccount.bind(this);
    this.handleRequestRunTest = this.handleRequestRunTest.bind(this);
    this.hideTestModal = this.hideTestModal.bind(this);
    this.handleExtraDataLoaded = this.handleExtraDataLoaded.bind(this);
    this.handleShowAccounts = this.handleShowAccounts.bind(this);
    this.handleRequestSendSummaryEmail = this.handleRequestSendSummaryEmail.bind(this);
    this.handleRequestSendReminderEmail = this.handleRequestSendReminderEmail.bind(this);
    this.requestChangeCommnunicationRecipient = this.requestChangeCommnunicationRecipient.bind(this);
    this.handleRequestPauseReminderEmail = this.handleRequestPauseReminderEmail.bind(this);
    this.extendSearch = this.extendSearch.bind(this);
    this.cache = new CellMeasurerCache({
      defaultHeight: 500,
      fixedWidth: true,
      minHeight: 250,
      keyMapper: this.keyMapper,
    });
  }


  componentDidMount() {
    this.props.dispatch(resetAll(false));
    Promise.all([
      this.props.dispatch(fetchTVProductMappings()),
      this.props.dispatch(fetchPrograms()),
      this.props.dispatch(resetAccountAutomationSettings()),
    ])
      .then(
        () => {
          this.setState({ loading: false });
        },
        () => {
          this.setState({ loading: false });
        },
      );
  }

  componentWillReceiveProps(nextProps) {
    const shouldLoad = (!this.props.winLossLoaded && nextProps.winLossLoaded) ||
      (!this.props.feedbackLoaded && nextProps.feedbackLoaded);
    if (shouldLoad) {
      this.refreshData(nextProps.accounts);
    }
  }
  
  handleExtraDataLoaded() {
    this.refreshData();
  }

  getActiveSortOption() {
    const { selectedSort } = this.state;
    return find(sortOptions, { value: selectedSort || 'close_date_desc' }) || first(sortOptions);
  }

  getActiveFilterOption() {
    const { selectedFilter } = this.state;
    return find(filterOptions, { value: selectedFilter }) || first(filterOptions);
  }

  getMatchedReasons(re, feedbacks) {
    return filter(feedbacks, (feedback) => {
      let matchCompetitor = false;
      let matchReason = false;
      let matchContact = false;
      let matchClassification = false;
      const isClient = feedback.is_client;
      if (isClient) {
        const contactName = feedback.contact_name || '';
        const label = feedback.label || '';
        const classification = feedback.classification_text || '';
        matchReason = label.match(re);
        matchContact = contactName.match(re);
        matchClassification = classification.match(re);
      } else {
        const competitor = feedback.vendor_name || '';
        matchCompetitor = competitor.match(re);
      }
      return matchCompetitor || matchReason || matchContact || matchClassification;
    });
  }

  handleExtraDataLoaded() {
    this.refreshData();
  }

  handleSendEmail(type, account, automationId) {
    let toastId = null;
    const toasterClose = () => {
      toastId = null;
    }
    const el = (
      <div><Fa name="spinner" spin /> Sending {type} email for <strong>{account.name}</strong>...</div>
    );

    toastId = this.context.addNotification(el, { type: 'warning', autoClose: false, onClose: toasterClose });
    const action = type === 'reminder' ? sendReminderEmail : sendSummaryEmail;
    this.props.dispatch(action(automationId, account.account_id, true))
      .then(
        (result) => {
          const hasError = result.error === true;
          const el = hasError ? 
              (<div>{result.message}. A {type} email has not been sent for <strong>{account.name}</strong></div>) :
              (<div>{capitalize(type)} email has been sent for <strong>{account.name}</strong></div>);
          if (toastId) {
            toast.update(toastId, { 
              render: () => el,
              type: hasError ? 'error' : 'success',
              autoClose: !hasError,
              onClose: toasterClose,
            });
          } else {
            toastId = this.context.addNotification(el, { type: hasError ? 'error' : 'success', autoClose: true, onClose: toasterClose });
          }
        },
        (e) => {
          const el = (<div>{(e.data?.message || e.message)}</div>);
          if (toastId) {
            toast.update(toastId, { 
              render: () => el,
              type: 'error',
              autoClose: false,
              onClose: toasterClose,
            });
          } else {
            toastId = this.context.addNotification(el, { type: 'error', autoClose: true, onClose: toasterClose });
          }
        }
      );
  }


  handleRequestPauseReminderEmail(account, pause = false) {
    const p = this.props.dispatch(updateReminderEmailStatus(account.account_id, pause, true));
    let toastId = null;
    const toasterClose = () => {
      toastId = null;
    }
    const el = (
      <div><Fa name="spinner" spin /> {pause ? 'Pause' : 'Resume'} reminder email...</div>
    );
    toastId = this.context.addNotification(el, { type: 'warning', autoClose: false, onClose: toasterClose });
    p.then(
        (result) => {
          const el = (<div>Reminder email has been {result.disabled ? 'paused' : 'resumed'} for <strong>{account.name}</strong></div>);
          if (toastId) {
            toast.update(toastId, { 
              render: () => el,
              type: 'success',
              autoClose: true,
              onClose: toasterClose,
            });
          } else {
            toastId = this.context.addNotification(el, { type: 'success', autoClose: true, onClose: toasterClose });
          }
        },
        (e) => {
          const el = (<div>{(e.data?.message || e.message)}</div>);
          if (toastId) {
            toast.update(toastId, { 
              render: () => el,
              type: 'error',
              autoClose: false,
              onClose: toasterClose,
            });
          } else {
            toastId = this.context.addNotification(el, { type: 'error', autoClose: true, onClose: toasterClose });
          }
        }
      );
    return p;
  }



  requestChangeCommnunicationRecipient(currentEditCommnunicationRecipient) {
    this.setState({ currentEditCommnunicationRecipient });
    return Promise.resolve();
  }

  handleRequestSendReminderEmail(account, automationId = null) {
    this.handleSendEmail('reminder', account, automationId);
  }

  handleRequestSendSummaryEmail(account, automationId = null) {
    this.handleSendEmail('summary', account, automationId);
  }

  getMatchedAccounts(accounts) {
    const { query } = this.state;
    const { columnData } = this.props;

    let items = accounts;
    if (query && query.length) {
      const re = new RegExp(query, 'i');
      items = filter(items, (account) => {
        let matchAccount = false;
        const matchFeedbacks = false;
        let matchMeta = false;
        let matchQuickSearch = false;


        if (re) {
          const accountName = account.name;
          matchAccount = accountName.match(re);
          matchQuickSearch = `${(account.quickSearchString || '')}`.match(re);

          const md = columnData[account.account_id] || {};
          each(md, (m) => {
            if (`${m}`.match(re) || m === query) {
              matchMeta = true;
            }
          });
          /*
          if (account.feedbacks && account.feedbacks.length) {
            matchFeedbacks = this.getMatchedReasons(re, account.feedbacks).length > 0;
          }
          */
        }
        return matchQuickSearch || matchAccount || matchFeedbacks || matchMeta;
      });
    }
    return items;
  }

  getFilterredOpportunities(accounts) {
    const sortOption = this.getActiveSortOption();
    const filterOption = this.getActiveFilterOption();
    let items = accounts;
    if (filterOption.filters) {
      items = filter(items, filterOption.filters);
    }
    items = this.getMatchedAccounts(items);
    const { sortKey, sortDir } = sortOption;
    items = orderBy(items, [sortKey], [sortDir]);
    return items;
  }

  keyMapper(index) {
    const { accounts } = this.props;
    const account = accounts[index];
    return account.account_id;
  }


  handleShowAccounts(selectedAccountIds, type, showExcluedReason = false) {
    this.setState({ selectedAccountIds, showExcluedReason });
  }


  handleRequestRunTest(account, automationId = null) {
    this.setState({ showTestModal: true, testOwnerId: account.owner_id, testAccountId: account.account_id, testAutomationId: automationId });
  }

  hideTestModal() {
    this.setState({ showTestModal: false }, () => {
      this.setState({
        testOwnerId: null,
        testAccountId: null,
      });
    });
  }

  handleRequestFetchCollectorStats(collector) {
    const { accounts } = this.props;
    const ids = map(filter(accounts, { has_requests: true }), 'account_id');
    if (ids.length === 0) {
      ids.push(accounts.length ? accounts[0].account_id : '');
    }
    this.props.dispatch(fetchCollectorStats(collector.collector_id, ids, true));
  }

  handleRequestCancel(currentCancelContact, currentCancelContactObject, cancelContactCallBack = () => {}) {
    this.setState({ currentCancelContact, currentCancelContactObject, cancelContactCallBack });
  }

  handleCancelOutreach(contact, reason) {
    const { currentCancelContactObject } = this.state;
    const isAccount = true;
    const contactId = contact.id;
    const collectorId = contact.collector_id;
    const id = currentCancelContactObject.account_id;
    const p = this.props.dispatch(winLossCancelSurveys(collectorId, id, contactId, isAccount, reason, contact));
    p.then(
      (c) => {
        if (this.state.cancelContactCallBack) {
          this.state.cancelContactCallBack(c);
          this.setState({ cancelContactCallBack: null });
        }
      },
    );
    return p;
  }

  handleIncludeAccount(account) {
    const p = this.props.dispatch(winLossIncludeAccount(account.account_id));
    p.then(() => {
      this.refreshData();
    });
    return p;
  }

  requestExcludeAccount(currentlyExcludedAccount) {
    this.requestAddAccountSurvey(null);
    this.setState({ currentlyExcludedAccount });
  }

  handleExcludeAccount(account, params) {
    const p = this.props.dispatch(winLossExcludeAccount(account.account_id, params));
    p.then(() => {
      this.props.dispatch(fetchWinLossAccountSurveys(account.account_id))
        .then(
          () => {
            this.refreshData();
          },
          () => {
            this.refreshData();
          },
        );
    });
    return p;
  }


  requestChangeLanguage(currentEditLanguageSurvey, selectedLanguage, availableLanguages, changeLanguageCallback = () => {}) {
    this.setState({
      currentEditLanguageSurvey,
      selectedLanguage,
      availableLanguages,
      changeLanguageCallback,
    });
    return Promise.resolve();
  }

  handleTabSelect(id, tab, cb) {
    this.setState({ tabs: { ...this.state.tabs, [id]: tab } }, cb);
  }

  handleOnAccountLogoLoaded(id, accountLogoUrl, colorPallete, cb) {
    this.setState({ colorPalletes: { ...this.state.colorPalletes, [id]: colorPallete } }, cb);
  }

  handleRequestShowInsight(id, insightId) {
    this.props.dispatch(fetchAccountInsights(id, insightId));
  }

  requestAddAccountSurvey(account) {
    this.props.dispatch(requestEditWinLossAccountFeedbacks(account));
  }

  handleSelectSortOption(selectedSort) {
    this.setState({ selectedSort }, this.refreshData);
  }

  handleSelectFilterOption(selectedFilter) {
    this.setState({ selectedFilter }, this.refreshData);
  }

  handleSelectAmountFieldOption(amountField) {
    if (amountField) {
      this.setState({ amountField }, this.refreshData);
    }
  }

  handleUpdateAccountStatus(account, status) {
    const p = this.props.dispatch(updateAccountStatus(account.account_id, status));
    p.then(() => { this.refreshData(); });
    return p;
  }

  handleRequestShowOutreachPlan(currentSurveyPlan) {
    this.setState({ currentSurveyPlan });
    return Promise.resolve();
  }

  handleOnSubmitContacts(account /* feedbacks, surveys */) {
    const { accounts } = this.state;
    const propAccounts = this.props.accounts;
    const id = account.account_id;
    const propAccount = find(propAccounts, { account_id: id });
    if (propAccount) {
      const indexed = findIndex(accounts, { account_id: id });
      if (indexed >= 0) {
        this.setState({ ...account, [indexed]: account }, this.refreshData);
      }
    }
  }

  handleSubmitContactAndDone(/* opportunity */) {
    // console.log('handleSubmitContactAndDone');
  }

  handleFormChange(criteria) {
    const {
      hasNoDecision,
    } = this.props;
    this.setState({ query: null, selectedFilter: null, backendQuickSearching: false, hasBackendResults: false });
    this.props.dispatch(resetAll(false))
      .then(() => {
        this.props.dispatch(loadSettings(null, true));
        this.setState({ tabs: {}, colorPalletes: {} });
        this.props.dispatch(fetchFeedbackExperienceOpportunities({ ...criteria }, hasNoDecision, includeResources))
          .then(
            (results) => {
              this.setState({ searchId: this.state.searchId + 1 });
              const { opportunities, total } = results;
              const opportunityIds = [];
              const accountIds = [];
              each(opportunities, (opportunity) => {
                opportunityIds.push(opportunity.opportunity_id);
                accountIds.push(opportunity.account_id);
              });
              this.props.dispatch(fetchOpportunityRequestStatus(accountIds, opportunityIds, 'account')); // yes, we search by opportunity id even for account base
              const returnResults = opportunities.length;
              if (total && returnResults < total) {
                const el = (
                  <div>
                    Your search return more than <NumberDisplay value={total} precision={0} /> results.<br />
                    For optimal performance, only the latest <NumberDisplay value={returnResults} precision={0} /> will be displayed.
                  </div>
                );
                this.context.addNotification(el, { type: 'warning', autoClose: 30 * 1000 });
              }
            },
          );
      });
  }

  hanldeReset() {
    this.props.dispatch(resetAll());
  }

  handleSearch(query) {
    this.setState({ query, hasBackendResults: false }, () => {
      if (query && query.length > 0) {
        const accounts = this.getMatchedAccounts(this.props.accounts); // is there any match yet
        if (accounts.length > 0 || query.length < LIMIT_CHARS) {
          // there is a match
           this.setState({
            priorityData: accounts,
          }, () => {
            this.refreshData();
          });
          this.refreshData();
        } else if (query.length >= LIMIT_CHARS) {
          this.refreshData(); // we need to refresh so the data display zero result and a loading bar
          this.performBackendQuickSearch();
        }
      } else if (!query || query.length === 0) {
        this.performBackendQuickSearch();
      }
    });
  }

  extendSearch(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (this.state.backendQuickSearching) {
      return;
    }
    if (this.state.query.length >= LIMIT_CHARS) {
      this.performBackendQuickSearch();
    }
  }

    performBackendQuickSearch() {
      if (this.state.backendQuickSearching) {
        return;
      }
      this.setState({ backendQuickSearching: true, priorityData: [] }, () => {
        const { hasNoDecision } = this.props;
        const empty = { query: { _id: 'ROOT', type: 'groupAND', values: [] } };
        this.props.dispatch(fetchFeedbackExperienceOpportunities({ q: this.state.query, query: empty }, hasNoDecision, includeResources, true))
          .then(
            ({ opportunities, total }) => {
              const opportunityIds = [];
              const accountIds = [];
              each(opportunities, (opportunity) => {
                opportunityIds.push(opportunity.opportunity_id);
                accountIds.push(opportunity.account_id);
              });
              this.props.dispatch(fetchOpportunityRequestStatus(accountIds, opportunityIds, 'account')); // yes, we search by opportunity id even for account base
              this.setState({ backendQuickSearching: false, hasBackendResults: true, priorityData: opportunities }, () => {
                this.refreshData();
              });
            },
            () => {
            }
          )
          .finally(() => {
          
          });
      });
    }

  requestChangeSenderEmail(currentEditSenderSurvey) {
    this.setState({ currentEditSenderSurvey });
    return Promise.resolve();
  }

  
  refreshData(inputAccounts = null) {
    const accounts = this.getFilterredOpportunities(inputAccounts || this.props.accounts);
    this.setState({ accounts }, () => {
      if (this.cache) {
        this.cache.clearAll();
      }
      delay(() => {
        if (this.list) {
          this.list.forceUpdateGrid();
        }
      }, 500);
    });
  }

  rowRenderer({
    index, key, style, parent, isVisible, isScrolling,
  }) {
    const {
      tabs, colorPalletes, amountField, selectedFilter,
    } = this.state;
    const { collectorStats, auth } = this.props;
    const { accounts } = this.state;
    const account = accounts[index];
    const id = account.account_id;
    const isLast = index === accounts.length - 1;
    return (
      <CellMeasurer
        cache={this.cache}
        columnIndex={0}
        key={key}
        parent={parent}
        rowIndex={index}
      >
        {({ measure }) => {
          const shouldRender = !isScrolling && isVisible;



          return (
            <div style={style}>
              <AccountBox
                auth={auth}
                isVisible={isVisible}
                account={account}
                collectorStats={collectorStats[id]}
                measure={measure}
                selectedFilter={selectedFilter}
                onTabSelect={(tab) => {
                  this.handleTabSelect(id, tab, measure);
                }}
                onLogoLoaded={(accountLogoUrl, colorPallete) => {
                  this.handleOnAccountLogoLoaded(id, accountLogoUrl, colorPallete, measure);
                }}
                requestShowInsight={(insightId) => {
                  this.handleRequestShowInsight(id, insightId);
                }}
                requestAddAccountSurvey={this.requestAddAccountSurvey}
                excludeAccount={this.requestExcludeAccount}
                includeAccount={this.handleIncludeAccount}
                tab={tabs[id]}
                colorPallete={colorPalletes[id]}
                amountField={amountField}
                updateAccountStatus={this.handleUpdateAccountStatus}
                requestShowOutreachPlan={this.handleRequestShowOutreachPlan}
                requestChangeSenderEmail={this.requestChangeSenderEmail}
                requestChangeCommnunicationRecipient={this.requestChangeCommnunicationRecipient}
                requestChangeLanguage={this.requestChangeLanguage}
                requestCancelContact={this.handleRequestCancel}
                isLast={isLast}
                emailAutomationsEnabled
                requestRunTest={this.handleRequestRunTest}
                showRunTestButton={this.props.canSetupOrg}
                showSendSummaryEmailButton={this.props.canSetupOrg}
                requestSendSummaryEmail={this.handleRequestSendSummaryEmail}
                showSendReminderEmailButton={this.props.canSetupOrg}
                requestSendReminderEmail={this.handleRequestSendReminderEmail}
                requestPauseReminderEmail={this.handleRequestPauseReminderEmail}
                enableChangeCommnunicationRecipient
              />

            </div>
          );
      }}
      </CellMeasurer>
    );
  }

  renderFilterDropdown() {
    const activeOption = this.getActiveFilterOption();
    return (
      <span>
        Show:&nbsp;
        <DropdownButton
          onSelect={this.handleSelectFilterOption}
          bsSize="sm"
          title={activeOption ? activeOption.label : 'All Deals'}
          id="feedback-filters"
        >
          {filterOptions.map(option => (
            <MenuItem
              active={activeOption && activeOption.value === option.value}
              key={option.value}
              eventKey={option.value}
            >
              {option.label}
            </MenuItem>
          ))}
        </DropdownButton>
      </span>
    );
  }

  renderSortDropdown() {
    const activeOption = this.getActiveSortOption();
    const activeLabel = activeOption ? activeOption.longLabel : 'no sorting';
    return (
      <span>
        Sort by:&nbsp;
        <DropdownButton
          onSelect={this.handleSelectSortOption}
          bsSize="sm"
          title={activeLabel}
          id="feedback-sort"
        >
          {sortOptions.map((option) => {
            if (option.isHeader) {
              return (
                <MenuItem key={option.value} header>{option.label}</MenuItem>
              );
            }
            return (
              <MenuItem
                active={activeOption && activeOption.value === option.value}
                key={option.value}
                eventKey={option.value}
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{option.label}
              </MenuItem>
            )
          })}
        </DropdownButton>
      </span>
    );
  }

  renderAmmountFieldDropdown() {
    const options = [
      {
        value: 'ttm', label: 'Trailing Twelve Month Amount', shortLabel: 'TTM Amount',
      },
      {
        value: 'ltv', label: 'Lifetime Amount', shortLabel: 'LTV Amount',
      },
    ];
    const activeOption = find(options, { value: this.state.amountField }) || first(options);

    const activeLabel = activeOption ? activeOption.shortLabel : 'Amount Field';
    return (
      <span>
        <DropdownButton
          onSelect={this.handleSelectAmountFieldOption}
          bsSize="sm"
          title={activeLabel}
          id="amount-field"
        >
          {options.map((option) => {
            if (option.isHeader) {
              return (
                <MenuItem key={option.value} header>{option.label}</MenuItem>
              );
            }
            return (
              <MenuItem
                active={activeOption && activeOption.value === option.value}
                key={option.value}
                eventKey={option.value}
              >
                &nbsp;&nbsp;&nbsp;{option.label}
              </MenuItem>
            );
          })}
        </DropdownButton>
      </span>
    );
  }

  renderControls() {
    return (
      <div key="controls" className={styles.controls}>
        <nav key="controls" className="navbar navbar-default navbar-controls">
          <form className="navbar-form navbar-left">
            <SearchField disabled={this.state.backendQuickSearching} onSearch={this.handleSearch} />
          </form>
          <div className="navbar-form navbar-right">
            {this.renderFilterDropdown()}
            &nbsp;&nbsp;&nbsp;
            {this.renderAmmountFieldDropdown()}
            &nbsp;&nbsp;&nbsp;
            {this.renderSortDropdown()}
          </div>
        </nav>
      </div>
    );
  }

  renderBackendSearchController() {
    const { query, backendQuickSearching, hasBackendResults, accounts } = this.state;
    const totalReturn = (accounts || []).length;
    if (backendQuickSearching) {
      return null;
    }
    if (hasBackendResults) {
      if (totalReturn > 0) {
        return (
          <div className="alert alert-warning">The current search includes additional results from backend.</div>
        );
      }
      return null;
    }
    if (!query || query.length < LIMIT_CHARS) {
      return null;
    }
    return (
      <div className="alert alert-success" onClick={this.extendSearch}>You can also <a className="text-active" href=""><u>extend the current search results</u></a> to include backend data for <code>{query}</code>.</div>
    );
  }


  renderList() {
    const { accounts, query, backendQuickSearching } = this.state;
    const isSearching = (query && query.length > 0);

    const totalReturn = (this.props.accounts || []).length;

    const activeOption = this.getActiveFilterOption();

    return [
      this.renderControls(),
      ...(isSearching ? [this.renderBackendSearchController()] : []),
      (
        <AutoSizer key="sizer" disableHeight>
          {({ width }) => (
            <WindowScroller>
              {({ height, isScrolling, scrollTop }) => (
                <div>
                  <List
                    autoHeight
                    height={height}
                    ref={(ref) => { this.list = ref; }}
                    isScrolling={isScrolling}
                    rowCount={accounts.length}
                    rowHeight={this.cache.rowHeight}
                    rowRenderer={this.rowRenderer}
                    scrollTop={scrollTop}
                    width={width}
                  />
                </div>
              )}
            </WindowScroller>
          )}
        </AutoSizer>
      ),

      accounts.length === 0 ? (
        <div key="warning" className="alert alert-warning" style={{ margin: '10px 3px' }}>
          {isSearching && 
            <div>
              {backendQuickSearching && 
                <div>
                  <p>One moment please. Performing a backend search for <code>{query}</code></p>
                  <ProgessBar />
                </div>
              }
              {!backendQuickSearching &&
                <div>
                  {query.length >= LIMIT_CHARS && <span>No results matching <code>{query}</code></span>}
                  {query.length < LIMIT_CHARS && <span>No results matching <code>{query}</code>. To perform a backend search, please type {LIMIT_CHARS} or more letters.</span>}
                </div>
              }
            </div>
          }
          {!isSearching &&
            <div>
              {totalReturn >= 0 &&
                <span>
                  Current search returns <NumberDisplay value={totalReturn} suffix="result" suffixIsUnit precision={0} />.
                  But no results matching active filter: {activeOption !== null && <strong>{activeOption.label}</strong>}.
                </span>
              }
              {totalReturn === 0 && <span>No results found.</span>}
            </div>
          }
        </div>
      ) : null,



      accounts.length > 0 ? (
        <div key="credits" className={styles.credits}>
          <a target="_blank" rel="noopener noreferrer" href="https://clearbit.com">
            <img src="//logo.clearbit.com/clearbit.com" alt="Clearbit Logo" /> Logos provided by Clearbit
          </a>
        </div>
      ) : null,
    ];
  }

  renderSideNav(collectors = []) {
    const {
      headerHeight, footerHeight, windowWidth,
    } = this.props;
    const cls = styles.contentSidebar;
    const isMobile = windowWidth < 768 && windowWidth > 0;
    if (isMobile) {
      return (
        <div className={cls}>
          <SideBox
            isAccount
            collectors={collectors}
            requestFetchCollectorStats={this.handleRequestFetchCollectorStats}
            requestShowObjects={this.handleShowAccounts}
          />
        </div>
      );
    }
    return (
      <StickyBox offsetTop={headerHeight} offsetBottom={footerHeight} className={cls}>
        <SideBox isAccount requestShowObjects={this.handleShowAccounts} collectors={collectors} requestFetchCollectorStats={this.handleRequestFetchCollectorStats} />
      </StickyBox>
    );
  }

  renderShimmers() {
    return range(10).map(r => <Shimmer key={r} />);
  }

  renderContent(collectors = []) {
    const {
      winLossLoading, winLossLoaded, feedbackLoaded,
      accounts, auth, canSetupOrg,
    } = this.props;
    const { selectedFilter, currentlyExcludedAccount } = this.state;
    const isLoading = !winLossLoaded || winLossLoading || !feedbackLoaded;
    if (winLossLoaded && accounts.length === 0 && selectedFilter === null) {
      return (
        <div className="alert alert-warning">
          No records found.
        </div>
      );
    }
    return (
      <div className={styles.content}>
        {this.renderSideNav(collectors)}
        <div className={styles.contentBody}>
          {isLoading && this.renderShimmers()}
          {!isLoading &&
            <div>
              {this.renderList()}
              <SurveyEmailModal />
              <OutreachPlanModal
                isAccount
                survey={this.state.currentSurveyPlan}
                onClose={() => { this.setState({ currentSurveyPlan: null }); }}
              />
              <EditSenderModal
                isAccount
                survey={this.state.currentEditSenderSurvey}
                onClose={() => { this.setState({ currentEditSenderSurvey: null }); }}
                onSuccess={() => { this.refreshData(); }}
              />
              <CommunicationRecipientModal
                object={this.state.currentEditCommnunicationRecipient}
                onClose={() => { this.setState({ currentEditCommnunicationRecipient: null }); }}
                isAccount
                onSuccess={() => { 
                  this.setState({ currentEditCommnunicationRecipient: null });
                  // this.refreshData(); 
                }}
              />
              <InsightModal />
              <RequestOpportunityFeedbacks
                onSuccess={this.handleOnSubmitContacts}
                onDone={this.handleSubmitContactAndDone}
                collectorTypes={['experience']}
                requestCancelContact={this.handleRequestCancel}
                requestChangeLanguage={this.requestChangeLanguage}
              />
              <ExcludeOpportunityForm
                opportunity={currentlyExcludedAccount}
                isAccount
                show={currentlyExcludedAccount !== null}
                onClose={() => { this.setState({ currentlyExcludedAccount: null }); }}
                requestExclude={this.handleExcludeAccount}
                auth={auth}
              />
              <AccountModal
                accountIds={this.state.selectedAccountIds}
                getAccounts={getWinLossAccounts}
                tableConfigs={{
                  isManager: true,
                  tableName: 'feedback-winloss-accounts',
                }}
                onClose={() => {
                  this.setState({ selectedAccountIds: [] });
                }}
                showExcluedReason={this.state.showExcluedReason}
              />
              <EditLanguageModal
                survey={this.state.currentEditLanguageSurvey}
                isAccount
                selectedLanguage={this.state.selectedLanguage}
                availableLanguages={this.state.availableLanguages}
                onClose={() => {
                  this.setState({
                    currentEditLanguageSurvey: null,
                    selectedLanguage: null,
                    availableLanguages: [],
                    changeLanguageCallback: null,
                  });
                }}
                onSuccess={(c) => {
                  this.refreshData();
                  if (this.state.changeLanguageCallback) {
                    this.state.changeLanguageCallback(c);
                    this.setState({ changeLanguageCallback: null });
                  }
                }}
              />
              {this.state.currentCancelContact !== null &&
                <CancelOutreachForm
                  show
                  contact={this.state.currentCancelContact}
                  onClose={() => { this.setState({ currentCancelContact: null, currentCancelContactObject: null, cancelContactCallBack: null }); }}
                  onRequestCancel={this.handleCancelOutreach}
                />
              }
              <ColumnDataManager 
                id="account-feedback-tile"
                key={this.props.accounts.length}
                getRowData={() => this.props.accounts}
                resourceType="ACCOUNT"
                onColumnLoaded={this.handleExtraDataLoaded}
                forceLoadSystemColumnTags={[]}
                searchId={`${this.state.searchId}|${this.props.accounts.length}`}
                priorityData={this.state.priorityData}
              />
              {winLossLoaded && canSetupOrg &&
                <AutomationTestModal
                  open={this.state.showTestModal}
                  onClose={this.hideTestModal}
                  ownerId={this.state.testOwnerId}
                  accountId={this.state.testAccountId}
                  automationId={this.state.testAutomationId}
                  isAccount
                />
              }
            </div>
          }
        </div>
      </div>
    );
  }

  render() {
    const {
      winLossPrograms,
      winLossLoaded, winLossLoading,
    } = this.props;
    const {
      loading,
    } = this.state;
    const hasWinLoss = winLossPrograms.length > 0;
    const isLoading = !winLossLoaded || winLossLoading;
    
    const topComponent = (
      <div className="clearfix">
        <div className="pull-left">
          <SubNav />
        </div>
        {!loading &&
          <div className="pull-right">
            <SearchForm
              onSearchChange={this.handleFormChange}
              onReset={this.hanldeReset}
              pullRight
              requireTeamSelector={false}
              selectDefaultTeam
              source="account"
              type="feedback/experience"
              defaultCriteria={{
                type: 'groupAND',
                values: [
                  {
                    tag: 'closeDate',
                    type: 'include',
                    values: 'last-90-days',
                  },
                ],
              }}
              disabledFilters={[]}
              disabled={isLoading}
            />
          </div>
        }
      </div>
    );

    return (
      <div className={styles.body}>
        <Helmet title="Experience | Feedback" />
        <BodyClassName className={styles.body} />
        <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Libre+Baskerville:400,200i&display=swap" />
        <div className="container">
          <RequiredTVCollectorMappingSetup types={['experience']}>
            {(collectors) => {
              return (
                <div>
                  {topComponent}
                  <p />
                  {!hasWinLoss && !loading &&
                    <div className="alert alert-danger">
                      No Programs found.
                    </div>
                  }
                  {hasWinLoss && !loading && this.renderContent(collectors)}
                </div>
              );
            }}
          </RequiredTVCollectorMappingSetup>
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const programs = getPrograms(state);
  const availablePrograms = ['Win Loss', 'Voice of the Buyer', 'Customer Experience'];
  let winLossPrograms = [];
  if (programs) {
    each(availablePrograms, (programType) => {
      if (programs[programType] && programs[programType].length) {
        winLossPrograms = concat(winLossPrograms, programs[programType]);
      }
    });
  }
  const auth = getUser(state);
  return {
    winLossPrograms,
    auth,
    winLossLoading: getWinLossLoading(state),
    winLossLoaded: getWinLossLoaded(state),
    accounts: getWinLossAccounts(state),
    hasNoDecision: getHasNoDecisionSetup(state),
    feedbackLoaded: getWinLossFeedbackLoaded(state),
    headerHeight: getHeaderHeight(state),
    footerHeight: getFooterHeight(state),
    windowWidth: getWindowWidth(state),
    collectorStats: getWinLossCollectorStats(state),
    canSetupOrg: getCanSetupOrganization(state),
    columnData: getColumnData(state),
  };
}

ExperiencePage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  winLossPrograms: PropTypes.arrayOf(PropTypes.shape({
    program_id: PropTypes.string,
    name: PropTypes.string,
    client_id: PropTypes.string,
  })),
  accounts: PropTypes.arrayOf(PropTypes.shape({})),
  winLossLoading: PropTypes.bool,
  winLossLoaded: PropTypes.bool,
  hasNoDecision: PropTypes.bool,
  feedbackLoaded: PropTypes.bool,
  headerHeight: PropTypes.number,
  footerHeight: PropTypes.number,
  windowWidth: PropTypes.number,
  collectorStats: PropTypes.shape({}),
  auth: PropTypes.shape({}),
  canSetupOrg: PropTypes.bool,
  columnData: PropTypes.shape({}),
};

ExperiencePage.defaultProps = {
  winLossPrograms: [],
  accounts: [],
  winLossLoading: false,
  winLossLoaded: false,
  hasNoDecision: false,
  feedbackLoaded: false,
  footerHeight: 0,
  headerHeight: 0,
  windowWidth: 0,
  collectorStats: {},
  auth: null,
  canSetupOrg: false,
  columnData: {},
};

ExperiencePage.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};
export default connect(mapStateToProps)(withRouter(ExperiencePage));
